function waSend(f){
  const d = new FormData(f);
  const msg = `Hola, soy ${d.get('nombre')||'—'}. Quiero un tatuaje estilo ${d.get('estilo')} en ${d.get('zona')||'(zona por decidir)'} — ${d.get('artista')}. Mi idea: ${d.get('idea')||'—'}`;
  window.open('https://wa.me/34619133039?text=' + encodeURIComponent(msg), '_blank');
}
document.querySelectorAll('.carousel,.ar-grid,.steps-grid,.pr-grid,.rev-strip').forEach(g => [...g.children].forEach((c, i) => c.dataset.d = i * 90));
const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { const d = +e.target.dataset.d || 0; setTimeout(() => e.target.classList.add('on'), d); io.unobserve(e.target); } }), { threshold: .1 });
document.querySelectorAll('.rv,.zoomrv').forEach(el => io.observe(el));
const foldC = document.getElementById('foldCar');
if (foldC) {
  const items = [...foldC.querySelectorAll('.fold-it')];
  const upd = () => {
    const mid = innerWidth / 2;
    items.forEach(it => {
      const r = it.getBoundingClientRect();
      const c = r.left + r.width / 2 - mid;
      const rot = Math.max(-46, Math.min(46, -c / 11));
      it.style.transform = `rotateY(${rot}deg)`;
    });
  };
  foldC.addEventListener('scroll', upd, { passive: true });
  addEventListener('resize', upd);
  setTimeout(upd, 100);
  /* offsetWidth, no getBoundingClientRect: el rect incluye el rotateY y da el
     ancho del trapecio (hasta 979px), no el de la foto -> la flecha se saltaba fotos */
  const step = () => items[0].offsetWidth + (parseFloat(getComputedStyle(foldC).columnGap) || 0);
  document.getElementById('foldPrev').onclick = () => foldC.scrollBy({ left: -step(), behavior: 'smooth' });
  document.getElementById('foldNext').onclick = () => foldC.scrollBy({ left: step(), behavior: 'smooth' });
  foldC.scrollLeft = (foldC.scrollWidth - foldC.clientWidth) / 2;
}
const why = document.querySelector('.why');
const whyLines = document.querySelectorAll('.why .line');
const whyCards = document.querySelectorAll('.wcard');
addEventListener('scroll', () => {
  if (!why) return;
  const r = why.getBoundingClientRect();
  const prog = Math.min(1, Math.max(0, (innerHeight - r.top) / (innerHeight + r.height)));
  whyLines.forEach(l => { const dir = +l.dataset.dir; l.style.transform = `translateX(${(prog - .5) * dir * -34}%)`; });
}, { passive: true });
/* rueda infinita arrastrable con inercia (Hype interactive-cards) */
const wheel = document.getElementById('wheel');
if (wheel) {
  const base = [...wheel.querySelectorAll('.wcard')];
  for (let i = 5; i < 30; i++) {
    const c = base[i % 5].cloneNode(true);
    c.style.setProperty('--fi', i);
    wheel.appendChild(c);
  }
}
if (wheel && matchMedia('(min-width:921px)').matches) {
  let rot = 0, vel = 0, drag = null, raf = 0;
  const apply = () => { wheel.style.setProperty('--rot', rot); };
  const snap = () => {
    const s = rot, d = Math.round(rot / 12) * 12 - s, t0 = performance.now();
    const step = n => {
      const p = Math.min(1, (n - t0) / 550);
      rot = s + d * (1 - Math.pow(1 - p, 3)); apply();
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
  };
  const spin = () => {
    vel *= .94; rot += vel; apply();
    if (Math.abs(vel) > .06) raf = requestAnimationFrame(spin); else snap();
  };
  wheel.querySelectorAll('.wcard').forEach(c => {
    c.addEventListener('pointerdown', e => {
      cancelAnimationFrame(raf);
      drag = { x: e.clientX, r: rot }; vel = 0;
      c.setPointerCapture(e.pointerId); e.preventDefault();
    });
    c.addEventListener('pointermove', e => {
      if (!drag) return;
      const nr = drag.r + (e.clientX - drag.x) * .05;
      vel = nr - rot; rot = nr; apply();
    });
    ['pointerup', 'pointercancel'].forEach(ev => c.addEventListener(ev, () => {
      if (!drag) return; drag = null;
      if (Math.abs(vel) > .1) spin(); else snap();
    }));
  });
}
/* parallax fondos + laterales estudio */
const pxs = [['.hero__bg', .12], ['.laser__bg', .1]].map(([s, f]) => [document.querySelector(s), f]).filter(x => x[0]);
const sideL = document.querySelector('.ab-side.l'), sideR = document.querySelector('.ab-side.r'), aboutSec = document.querySelector('.about');
addEventListener('scroll', () => {
  pxs.forEach(([el, f]) => { const r = el.parentElement.getBoundingClientRect(); el.style.transform = `translateY(${(r.top + r.height / 2 - innerHeight / 2) * -f}px)`; });
  if (aboutSec && innerWidth > 920) {
    const r = aboutSec.getBoundingClientRect();
    const p = (innerHeight - r.top) / (innerHeight + r.height) - .5;
    if (sideL) sideL.style.transform = `translateY(${p * -120}px)`;
    if (sideR) sideR.style.transform = `translateY(${p * 100}px)`;
  }
}, { passive: true });
const sw = document.getElementById('stickyWa');
addEventListener('scroll', () => { sw.classList.toggle('show', scrollY > innerHeight * .8); }, { passive: true });
const burger = document.getElementById('burger'), mnav = document.getElementById('mnav');
const mnavBd = document.getElementById('mnavBd'), mnavX = document.getElementById('mnavX');
/* el panel se pone por encima del nav, asi que el boton que lo abre queda
   debajo: sin aspa, fondo y Escape no habia manera de cerrarlo */
const mToggle = open => {
  mnav.classList.toggle('open', open);
  burger.classList.toggle('x', open);
  document.body.classList.toggle('mnav-lock', open);
  if (mnavBd) mnavBd.classList.toggle('on', open);
};
burger.onclick = () => mToggle(!mnav.classList.contains('open'));
const menuBtn = document.getElementById('menuBtn');
if (menuBtn) menuBtn.onclick = () => mToggle(!mnav.classList.contains('open'));
if (mnavX) mnavX.onclick = () => mToggle(false);
if (mnavBd) mnavBd.onclick = () => mToggle(false);
addEventListener('keydown', e => { if (e.key === 'Escape' && mnav.classList.contains('open')) mToggle(false); });
mnav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => mToggle(false)));
const carC = document.querySelector('#estilos .carousel');
if (carC) {
  const cstep = () => carC.querySelector('.st-card').getBoundingClientRect().width + 16;
  document.getElementById('carPrev').onclick = () => carC.scrollBy({ left: -cstep(), behavior: 'smooth' });
  document.getElementById('carNext').onclick = () => carC.scrollBy({ left: cstep(), behavior: 'smooth' });
}

/* ===== HYPE FX ===== */
const rMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

/* glyph scramble */
const GLYPHS = 'ラドクリフマラソンわたしワタシんょンョたばこタバコとうきょうトウキョウ0123456789±!@#$%^&*()_+ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const rg = () => GLYPHS[Math.random() * GLYPHS.length | 0];
document.querySelectorAll('.glyph').forEach(el => {
  const t = el.textContent; el.textContent = '';
  let i = 0;
  t.split(/(\s+)/).forEach(tok => {
    if (!tok) return;
    if (/^\s+$/.test(tok)) { const sp = document.createElement('span'); sp.className = 'gsp'; sp.textContent = ' '; el.appendChild(sp); i++; return; }
    const w = document.createElement('span'); w.className = 'gw';
    [...tok].forEach(ch => {
      const s = document.createElement('span');
      s.className = 'g'; s.dataset.char = ch; s.textContent = ch;
      s.style.setProperty('--i', i++);
      s.style.setProperty('--c1', '"' + rg() + '"');
      s.style.setProperty('--c2', '"' + rg() + '"');
      s.style.setProperty('--c3', '"' + rg() + '"');
      w.appendChild(s);
    });
    el.appendChild(w);
  });
});

/* polaroids vuelan al entrar */
const whySec = document.querySelector('.why');
if (whySec) {
  const io2 = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { whySec.classList.add('dealt'); setTimeout(() => whySec.classList.add('fanned'), 1500); setTimeout(() => whySec.classList.add('live'), 2800); io2.disconnect(); } }), { threshold: .18 });
  io2.observe(whySec);
}

/* tilt 3D en tarjetas de precio */
if (matchMedia('(pointer:fine)').matches) document.querySelectorAll('.pr-card').forEach(c => {
  c.addEventListener('mousemove', e => {
    const r = c.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
    c.style.transition = 'transform .12s';
    c.style.transform = 'perspective(900px) rotateY(' + (x * 7) + 'deg) rotateX(' + (-y * 7) + 'deg) translateY(-4px)';
  });
  c.addEventListener('mouseleave', () => {
    c.style.transition = 'transform .7s cubic-bezier(.16,1,.3,1)';
    c.style.transform = '';
  });
});

/* fotos que siguen al cursor en stats (Hype) */
const statsEl = document.querySelector('.stats'), sFollow = document.getElementById('statFollow');
if (statsEl && sFollow && matchMedia('(pointer:fine)').matches) {
  const sfs = sFollow.querySelectorAll('.sf');
  let tx = 0, ty = 0, cx = 0, cy = 0, srot = 0, vis = false, sraf = 0;
  const sloop = () => {
    cx += (tx - cx) * .11; cy += (ty - cy) * .11;
    const dx = tx - cx;
    srot += (Math.max(-14, Math.min(14, dx * .1)) - srot) * .12;
    sFollow.style.transform = `translate(${cx}px,${cy}px) rotate(${srot}deg)`;
    sraf = requestAnimationFrame(sloop);
  };
  statsEl.addEventListener('mousemove', e => {
    const r = statsEl.getBoundingClientRect();
    tx = e.clientX - r.left - sFollow.offsetWidth / 2;
    ty = e.clientY - r.top - sFollow.offsetHeight / 2;
    if (!vis) { vis = true; sFollow.style.opacity = 1; cx = tx; cy = ty + 30; if (!sraf) sloop(); }
  });
  statsEl.addEventListener('mouseleave', () => { vis = false; sFollow.style.opacity = 0; });
  statsEl.querySelectorAll('.stat').forEach((s, i) => s.addEventListener('mouseenter', () => {
    sfs.forEach((f, j) => f.classList.toggle('on', j === i));
  }));
}

/* tinta que sigue al cursor (Hype canvas trail) */
const ink = document.getElementById('ink');
if (ink && !rMotion) {
  const ctx = ink.getContext('2d');
  let moved = false;
  const P = { n: 40, w: innerWidth < 920 ? .2 : .3, spring: .4, fric: .5 };
  const ptr = { x: innerWidth / 2, y: innerHeight / 2 };
  const trail = Array.from({ length: P.n }, () => ({ x: ptr.x, y: ptr.y, dx: 0, dy: 0 }));
  const setPtr = (x, y) => { ptr.x = x; ptr.y = y; };
  addEventListener('mousemove', e => { moved = true; setPtr(e.clientX, e.clientY); });
  addEventListener('touchmove', e => { moved = true; setPtr(e.targetTouches[0].clientX, e.targetTouches[0].clientY); }, { passive: true });
  const fit = () => { ink.width = innerWidth; ink.height = innerHeight; };
  fit(); addEventListener('resize', fit);
  ctx.strokeStyle = '#EDEAE4';
  const draw = t => {
    if (!moved) {
      ptr.x = (0.5 + 0.3 * Math.cos(0.002 * t) * Math.sin(0.005 * t)) * innerWidth;
      ptr.y = (0.5 + 0.2 * Math.cos(0.005 * t) + 0.1 * Math.cos(0.01 * t)) * innerHeight;
    }
    ctx.clearRect(0, 0, ink.width, ink.height);
    ctx.strokeStyle = '#EDEAE4';
    trail.forEach((p, i) => {
      const prev = i === 0 ? ptr : trail[i - 1];
      const spr = i === 0 ? .4 * P.spring : P.spring;
      p.dx += (prev.x - p.x) * spr; p.dy += (prev.y - p.y) * spr;
      p.dx *= P.fric; p.dy *= P.fric;
      p.x += p.dx; p.y += p.dy;
    });
    ctx.lineCap = 'round';
    ctx.beginPath();
    ctx.moveTo(trail[0].x, trail[0].y);
    for (let i = 1; i < trail.length - 1; i++) {
      const xc = .5 * (trail[i].x + trail[i + 1].x), yc = .5 * (trail[i].y + trail[i + 1].y);
      ctx.quadraticCurveTo(trail[i].x, trail[i].y, xc, yc);
      ctx.lineWidth = P.w * (P.n - i);
      ctx.stroke();
    }
    ctx.lineTo(trail[trail.length - 1].x, trail[trail.length - 1].y);
    ctx.stroke();
    requestAnimationFrame(draw);
  };
  requestAnimationFrame(draw);
}

/* ficha de producto: si la variante es un importe con muchas opciones (el vale
   regalo tiene 46), se cambia la lista de Dawn por el selector numerico de casa */
function ceMountAmount() {
  if (!document.body.classList.contains('ce-product')) return;
  if (document.querySelector('.ce-amtw')) return;
  const box = document.querySelector('.product-form__input--pill, .product-form__input--dropdown');
  if (!box) return;
  const radios = [...box.querySelectorAll('input[type="radio"]')];
  const sel = box.querySelector('select');
  const opts = radios.length ? radios.map(r => ({ v: parseInt(r.value, 10), el: r }))
    : sel ? [...sel.options].map(o => ({ v: parseInt(o.value, 10), el: o })) : [];
  const valid = opts.filter(o => !isNaN(o.v));
  if (valid.length < 9 || valid.length !== opts.length) return;

  const nums = valid.map(o => o.v).sort((a, b) => a - b);
  const MIN = nums[0], MAX = nums[nums.length - 1];
  const cur = radios.length ? (radios.find(r => r.checked) || radios[0]) : null;
  let val = cur ? parseInt(cur.value, 10) : (sel ? parseInt(sel.value, 10) : MIN);

  const w = document.createElement('div');
  w.className = 'gft__buy ce-amtw';
  w.innerHTML =
    '<span class="lt gft__lbl">Elige el importe</span>' +
    '<div class="gft__amt">' +
    '<button class="gft__st" type="button" data-s="-10" aria-label="Bajar 10 euros">&ndash;</button>' +
    '<span class="gft__num"><input type="number" min="' + MIN + '" max="' + MAX + '" step="10" value="' + val +
    '" inputmode="numeric" aria-label="Importe del vale en euros"><b>&euro;</b></span>' +
    '<button class="gft__st" type="button" data-s="10" aria-label="Subir 10 euros">+</button></div>' +
    '<div class="gft__chips">' + [50, 100, 150, 250].filter(a => nums.includes(a))
      .map(a => '<button class="gft__chip" type="button" data-a="' + a + '">' + a + ' &euro;</button>').join('') +
    '</div><p class="gft__fine">M&iacute;nimo ' + MIN + ' &euro; &middot; de 10 en 10</p>';
  box.classList.add('ce-off');
  box.parentNode.insertBefore(w, box);

  const inp = w.querySelector('input');
  const chips = [...w.querySelectorAll('.gft__chip')];
  const pick = v => {
    const near = nums.reduce((a, b) => Math.abs(b - v) < Math.abs(a - v) ? b : a, MIN);
    inp.value = near;
    chips.forEach(c => c.classList.toggle('on', +c.dataset.a === near));
    const hit = valid.find(o => o.v === near);
    if (!hit) return;
    /* ojo: marcar checked antes de click() se come el evento change y Dawn no
       repinta el precio; hay que lanzarlo a mano */
    if (radios.length) { hit.el.checked = true; hit.el.dispatchEvent(new Event('change', { bubbles: true })); }
    else { sel.value = hit.el.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
  };
  inp.addEventListener('change', () => pick(Math.round((parseInt(inp.value, 10) || MIN) / 10) * 10));
  inp.addEventListener('blur', () => pick(Math.round((parseInt(inp.value, 10) || MIN) / 10) * 10));
  w.querySelectorAll('.gft__st').forEach(b => b.addEventListener('click',
    () => pick((parseInt(inp.value, 10) || MIN) + (+b.dataset.s))));
  chips.forEach(c => c.addEventListener('click', () => pick(+c.dataset.a)));
  chips.forEach(c => c.classList.toggle('on', +c.dataset.a === val));
}
/* Dawn repinta la columna de info al cambiar de variante y se lleva el widget
   por delante: hay que volver a montarlo cada vez que rehace ese bloque. */
if (document.body.classList.contains('ce-product')) {
  ceMountAmount();
  const info = document.querySelector('.product__info-container');
  if (info) {
    let t = 0;
    new MutationObserver(() => {
      clearTimeout(t);
      t = setTimeout(ceMountAmount, 60);
    }).observe(info, { childList: true, subtree: true });
  }
}

/* vale regalo: el importe lo elige quien compra (minimo 50, de 10 en 10) */
const gForm = document.getElementById('gftForm');
if (gForm) {
  let map = {};
  try { map = JSON.parse(gForm.dataset.variants || '{}'); } catch (e) { map = {}; }
  const amounts = Object.keys(map).map(Number).filter(n => n).sort((a, b) => a - b);
  const inp = document.getElementById('gftAmt'), vid = document.getElementById('gftVar');
  if (amounts.length && inp && vid) {
    const MIN = amounts[0], MAX = amounts[amounts.length - 1];
    const chips = [...gForm.querySelectorAll('.gft__chip')];
    /* el importe se refleja en la tarjeta y en la linea de pago: asi se ve que
       lo que hay aqui es una compra de verdad */
    const card = document.getElementById('gftCardAmt');
    const pay = document.getElementById('gftPay');
    const sync = () => {
      let v = parseInt(inp.value, 10);
      if (isNaN(v)) v = MIN;
      v = Math.min(MAX, Math.max(MIN, Math.round(v / 10) * 10));
      if (!map[v]) v = amounts.reduce((a, b) => Math.abs(b - v) < Math.abs(a - v) ? b : a, MIN);
      inp.value = v;
      vid.value = map[v];
      chips.forEach(c => c.classList.toggle('on', +c.dataset.a === v));
      if (card) card.textContent = v + ' €';
      if (pay) pay.textContent = 'Pagas ' + v + ' €';
      return v;
    };
    inp.addEventListener('change', sync);
    inp.addEventListener('blur', sync);
    gForm.querySelectorAll('.gft__st').forEach(b => b.addEventListener('click', () => {
      inp.value = (parseInt(inp.value, 10) || MIN) + (+b.dataset.s);
      sync();
    }));
    chips.forEach(c => c.addEventListener('click', () => { inp.value = c.dataset.a; sync(); }));
    gForm.addEventListener('submit', sync);
    sync();
  }
}

/* el play del proceso sigue al raton por toda la seccion (Hype work in motion) */
const reelSec = document.querySelector('.reel');
const reelTile = reelSec && reelSec.querySelector('.tile');
const reelPlay = reelTile && reelTile.querySelector('.play');
if (reelSec && reelTile && reelPlay && matchMedia('(pointer:fine)').matches && !rMotion) {
  reelSec.classList.add('pf');
  let tx = 0, ty = 0, cx = 0, cy = 0, praf = 0, inside = false;
  const rest = () => {
    const t = reelTile.getBoundingClientRect(), p = reelPlay.getBoundingClientRect();
    return { x: t.width * 1.032 - p.width / 2, y: t.height / 2 };
  };
  const loop = () => {
    const k = inside ? .16 : .09;
    cx += (tx - cx) * k; cy += (ty - cy) * k;
    reelPlay.style.setProperty('--px', cx + 'px');
    reelPlay.style.setProperty('--py', cy + 'px');
    if (Math.abs(tx - cx) > .4 || Math.abs(ty - cy) > .4) praf = requestAnimationFrame(loop);
    else praf = 0;
  };
  const kick = () => { if (!praf) praf = requestAnimationFrame(loop); };
  const home = () => { const r = rest(); tx = r.x; ty = r.y; kick(); };
  const jump = () => { const r = rest(); cx = tx = r.x; cy = ty = r.y; loop(); };
  jump();
  addEventListener('resize', home);
  reelSec.addEventListener('mousemove', e => {
    const t = reelTile.getBoundingClientRect();
    inside = true;
    tx = e.clientX - t.left; ty = e.clientY - t.top;
    kick();
  });
  reelSec.addEventListener('mouseleave', () => { inside = false; home(); });
  /* toda la fila es zona de play, como en hype */
  const rrow = reelSec.querySelector('.reel-row');
  if (rrow) rrow.addEventListener('click', e => {
    if (e.target.closest('a')) return;
    reelTile.click();
  });
}

/* las tarjetas nacen ya colocadas: si el visitante pasa rapido no las pilla a medio vuelo */
(function(){
  const w = document.querySelector('.why');
  if (w) { w.classList.add('dealt','fanned','live'); }
})();